import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {  UntypedFormGroup } from '@angular/forms';

import {ResetPasswordDtoResponse} from '../../response/ResetPasswordDtoResponse';
import {ResetPasswordDto} from '../../model/ResetPasswordDto';
import { AuthenticationService } from '../../helper/authentication.service';
@Component({
  selector: 'app-verificationtoken',
  templateUrl: './verificationtoken.component.html',
  styleUrls: ['./verificationtoken.component.css']
})
export class VerificationTokenComponent {

        form: UntypedFormGroup;
        loading = false;
        submitted = false;
        returnUrl: string;
       
        resetPasswordDto  :ResetPasswordDto= new ResetPasswordDto();

        resetPasswordDtoResponse :ResetPasswordDtoResponse = new ResetPasswordDtoResponse();
  constructor(private router: Router,private route: ActivatedRoute,
          
          private authenticateService:AuthenticationService,
          
          )

          {
              console.log('Welcome')
             
            var token  = this.route.snapshot.paramMap.get("token");
            console.log('token>>>'+token);

                this.authenticateService.validateToken(token).subscribe((data:any)=>{
                  this.resetPasswordDtoResponse=data;
                  debugger
                  if(this.resetPasswordDtoResponse.viewName =="resetpassword"){
                     
                    console.log("resetpassword"+this.resetPasswordDtoResponse.viewName);
                     localStorage.setItem("resetpassworddto_id",this.resetPasswordDtoResponse.resetPasswordDto.userId.toString());
                    this.router.navigate(['/resetpassword']);
                  }else
                  {
                     
                    console.log("login"+this.resetPasswordDtoResponse.viewName);
                    this.router.navigate(['/login'])
                  }
                }
                );
             }











}
